import FetchUtils, { FORBIDDEN_QUERY_PARAM_KEYS, parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
import { flattenArrayValues } from '../utils/DataAccessUtils';

const fetchUtils = new FetchUtils();

export const EXPORT_PREVIEW_ROW_COUNT = 10;

// Where each exportable list mounts its export endpoints (`export_fields`, `download`, `csv_report_generator`).
export const EXPORT_ENTITY_PATHS = {
	work_orders: 'work_order/work_orders',
};

export interface ExportSorting {
	sort_by?: string;
	order?: string;
}

const sortingQuery = (sorting: ExportSorting) =>
	sorting && sorting.sort_by
		? {
				sort_by: sorting.sort_by,
				order: sorting.order === 'ascend' || sorting.order === 'asc' ? 'asc' : 'desc',
		  }
		: {};

// Every export endpoint reads the list's filters from the body, the same way the list's POST search does.
const postExportRequest =
	(roleType: string, entityType: string, endpoint: string, queryParams, filters, extraBody) =>
	(dispatch) =>
		new Promise<any>((resolve, reject) => {
			const queryString = fetchUtils.getQueryString(fetchUtils.sanitize(queryParams));
			const body = {
				...fetchUtils.sanitize(flattenArrayValues(filters || {}), FORBIDDEN_QUERY_PARAM_KEYS),
				...extraBody,
			};
			const url = `${getBackendUri()}/api/v1/${roleType}/${
				EXPORT_ENTITY_PATHS[entityType]
			}/${endpoint}`;
			fetchUtils
				.post(url + (queryString ? `?${queryString}` : ''), {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: body,
				})
				.then(parseJSON)
				.then(({ json, status }) => {
					if (status === 401) {
						dispatch(logoutSuccess());
						reject('unauthorized');
					} else if (json.status === 'error') {
						reject(json.message);
					} else {
						resolve(json.data);
					}
				})
				.catch((error) => reject(error.message));
		});

export const fetchExportFields = (roleType: string, entityType: string) => (filters) =>
	postExportRequest(roleType, entityType, 'export_fields', {}, filters, {});

export const fetchExportPreviewRows =
	(roleType: string, entityType: string) => (filters, sorting: ExportSorting) =>
		postExportRequest(
			roleType,
			entityType,
			'download',
			{ offset: 0, limit: EXPORT_PREVIEW_ROW_COUNT, ...sortingQuery(sorting) },
			filters,
			{}
		);

export const queueExport =
	(roleType: string, entityType: string) =>
	(filters, sorting: ExportSorting, columns, fileFormat: string) =>
		postExportRequest(
			roleType,
			entityType,
			'csv_report_generator',
			sortingQuery(sorting),
			filters,
			{
				columns,
				fileFormat,
			}
		);
